import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-98" data-mp="1hbgu4bwv3v38">
      <div className="mx-auto max-w-2xl" data-id="element-99" data-mp="1cfjfqb55syt3">
        <div className="text-center" data-id="element-100" data-mp="1ccncq8egfjxs">
          <h2 className="font-serif-display text-2xl font-bold text-plum sm:text-4xl" data-id="element-101" data-mp="2a2icelvuq6qz">
            Preguntas frecuentes
          </h2>
          <p className="mt-3 text-sm text-plum/75 sm:text-base" data-id="element-102" data-mp="253p19041ertz">
            Todo lo que necesitás saber antes de comenzar.
          </p>
        </div>

        <div className="mt-8 space-y-3" data-id="element-103" data-mp="1v5hicbq6tzpc">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className={`overflow-hidden rounded-2xl border bg-card transition-colors duration-200 ease-out ${isOpen ? 'border-gold/50' : 'border-aura/15'}`} data-id="element-104" data-mp="oqgxp26m53y2" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[56px] w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-105" data-mp="1pn33zyc6yh2w">
                  <span className="text-sm font-semibold leading-snug text-plum sm:text-base" data-id="element-106" data-mp="11wpa02a1q85o">
                    {faq.question}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-aura/10 text-aura" data-id="element-107" data-mp="16pa1uy9e6b6k">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="wxcpho6ndd69" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="iy4nknj3nqyd" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-110" data-mp="mz6ln11a5wyr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-111" data-mp="2po7yzl2z7cxh">
                      <p className="border-t border-gold/25 px-5 pb-4 pt-4 text-sm leading-relaxed text-plum/75" data-id="element-112" data-mp="38m10cixybesr">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}